<template>
  <CollapsableListItem class="item position-relative" :class="{current: isCurrent}">
    <template v-slot:controls>
      <div class="d-flex">
        <div class="mr-auto d-flex gap-1 align-items-center" style>
          <slot name="badges"></slot>
        </div>
        <div>
          <div class="dropdown">
            <button class="btn btn-invisible btn-sm" type="button" data-toggle="dropdown" aria-expanded="false">
              <i class="fas fa-ellipsis-v"></i>
            </button>
            <div class="dropdown-menu">
              <slot name="menu"></slot>
              <div v-if="isMenuEmpty" class="text-muted text-center">Empty</div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:header>
      <slot name="header"></slot>
    </template>
    <template v-slot:body>
      <slot name="body"></slot>
    </template>
  </CollapsableListItem>
</template>

<script>
import CollapsableListItem from "./collapsable-list-item.vue";
import {isBlank} from "../../../../helpers";

export default {
  components: {CollapsableListItem},

  props: {
    isCurrent: null,
    minHeight: Number,
    maxHeight: Number,
  },

  computed: {
    /**
     * @return {boolean}
     */
    isMenuEmpty() {
      return _.every(this.$slots.menu, this.isVnodeEmpty);
    },
  },

  methods: {
    /**
     * @param vnode
     * @return {boolean}
     */
    isVnodeEmpty(vnode) {
      return isBlank(_.get(vnode, 'tag'))
        && (_.get(vnode, 'isComment') === true || isBlank(_.get(vnode, 'text')));
    },
  },
}
</script>
